import Calendar from '../components/shared/calendar/en.json';
import Cep from '../components/shared/cep/en.json';
import Menu from '../components/shared/menu/en.json';
import Pagination from '../components/shared/pagination/en.json';
import UploadImage from '../components/shared/uploadImage/en.json';

export default {
  en: {
    translations: {
      ...Menu,
      ...Calendar,
      ...Pagination,
      ...Cep,
      ...UploadImage
    }
  }
};
